import React, { useState } from 'react';
import { Section } from './ui/Section';
import { AccordionItem } from './ui/Accordion';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el acceso a todos los tomos y bonos en formato PDF digital. Acceso en menos de 5 minutos.'
}, {
  q: '¿Sirve para profesores con poca experiencia o solo para los avanzados?',
  a: 'Sirve para todos los niveles de experiencia docente. Si estás empezando, el material te da la base y la estructura que nadie te enseñó. Si ya tenés años de experiencia, vas a encontrar herramientas nuevas y un sistema que ordena todo lo que ya sabés.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'El material se entrega en PDF listo para usar. Podés imprimirlo, guardarlo y usarlo en tus clases. No está habilitado para edición ni para redistribución.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos en ambas opciones sin costo adicional. La diferencia del Pack Élite™ son los 2 módulos exclusivos de competencia y gestión.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Funciona perfecto para ambos formatos. Todos los recursos incluyen variantes para clase individual, duplas y grupos de cualquier tamaño.'
}, {
  q: '¿Sirve si tengo alumnos de distintas edades al mismo tiempo?',
  a: 'Sí, especialmente para eso. Cada tomo incluye variaciones por nivel para que puedas trabajar con grupos heterogéneos sin improvisar ni dejar a nadie atrás.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de patinaje?',
  a: 'Es el único sistema en español diseñado específicamente para profesores de patinaje artístico en Argentina. No son apuntes genéricos: son clases listas, fichas técnicas específicas del patinaje y recursos que podés usar mañana mismo en tu pista.'
}, {
  q: '¿Por qué elegir el Pack Élite y no el estándar?',
  a: 'Si solo querés resolver tus clases del año, el pack estándar es más que suficiente. Si además querés preparar alumnos para competencia o hacer crecer tu academia de forma profesional, el Pack Élite™ te da las herramientas para ese siguiente nivel.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas ni formularios. Así de simple.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <Section className="bg-slate-50" data-id="element-66">
      <div className="text-center mb-6 md:mb-12" data-id="element-67">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-2 md:mb-4 text-brand-dark" data-id="element-68">
          PREGUNTAS FRECUENTES
        </h2>
        <div className="w-16 md:w-24 h-1 bg-brand-accent mx-auto rounded-full mt-4 md:mt-6" data-id="element-69"></div>
      </div>

      <div className="max-w-3xl mx-auto" data-id="element-70">
        {faqs.map((faq, index) => <AccordionItem key={index} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} title={<h3 className="font-bold text-brand-dark text-sm md:text-lg" data-id="element-72">
                {faq.q}
              </h3>} data-id="element-71">
            <p className="text-xs md:text-base text-slate-600 leading-relaxed" data-id="element-73">
              {faq.a}
            </p>
          </AccordionItem>)}
      </div>
    </Section>;
}